// Fix bug on browsers without console.
$(function() {

    /* Setup the homepage slideshow */

    $(".rslides").responsiveSlides({
      auto: true,             // Boolean: Animate automatically, true or false
      speed: 1600,            // Integer: Speed of the transition, in milliseconds
      timeout: 6000,          // Integer: Time between slide transitions, in milliseconds
      pager: false,           // Boolean: Show pager, true or false
      nav: false,             // Boolean: Show navigation, true or false
      random: false,          // Boolean: Randomize the order of the slides, true or false
      pause: false,           // Boolean: Pause on hover, true or false
      pauseControls: true,    // Boolean: Pause when hovering controls, true or false
      prevText: "Previous",   // String: Text for the "previous" button
      nextText: "Next",       // String: Text for the "next" button
      maxwidth: "",           // Integer: Max-width of the slideshow, in pixels
      navContainer: "",       // Selector: Where controls should be appended to, default is after the 'ul'
      manualControls: "",     // Selector: Declare custom pager navigation
      namespace: "rslides",   // String: Change the default namespace used
      before: function(){},   // Function: Before callback
      after: function(){}     // Function: After callback
    });


    $('input.quantity-selector').each(function(){
    $(this).wrap('<div class="js-qty-custom">');
    $(this).before('<button type="button" class="js-qty__adjust js-qty__adjust--minus icon-fallback-text" data-id="" data-qty=""><span class="icon icon-minus" aria-hidden="true"></span><span class="fallback-text" aria-hidden="true">−</span><span class="visually-hidden">Reduce item quantity by one</span></button>');
    $(this).after('<button type="button" class="js-qty__adjust js-qty__adjust--plus icon-fallback-text" data-id="" data-qty=""><span class="icon icon-plus" aria-hidden="true"></span><span class="fallback-text" aria-hidden="true">+</span><span class="visually-hidden">Increase item quantity by one</span></button>');
    $(this).addClass('js-qty__num');
    $(this).attr('type', 'text');

    $('button.js-qty__adjust--plus').click(function(){
      var $this = $(this),
          $qtySelector = $this.siblings('.js-qty__num');
          adjustQuantity($qtySelector, 'plus');
    });

    $('button.js-qty__adjust--minus').click(function(){
      var $this = $(this),
          $qtySelector = $this.siblings('.js-qty__num');
          adjustQuantity($qtySelector, 'minus');
    });

    function adjustQuantity($qtySelector, operator){
      qty = parseInt($qtySelector.val().replace(/[^0-9.]/g, ''));

      if(!((parseFloat(qty) == parseInt(qty)) && !isNaN(qty))) {
        qty = 1;
      }else{
        if(operator == 'plus'){
          qty++;
        }else if(qty > 1){
          qty--;
        }
      }

      $qtySelector.val(qty);
    }

  });
  
  $(document).ready(function(){
        console.log($('div.video-wrapper').find('iframe'));
        $('div.video-wrapper').find('iframe').each(function(){
          var $this = $(this);
          var width = $this.attr('width');
          var height = $this.attr('height');
          if(width !== undefined){
            $this.width(width);
          }
          if(height !== undefined){
            $this.height(height);
          }
        });
      });

});


